










































import { Component, PropSync, Vue } from 'vue-property-decorator';

import { CustomerNotificationItem } from '@/modules/customer/customer-notification/domain/dtos';

@Component({
  name: 'NotificationItem',
  components: {},
})
export default class NotificationItem extends Vue {
  @PropSync('customerNotification', { type: Object, required: true })
  synced_customer_notification!: CustomerNotificationItem;

  callAction(notification_type: string) {
    this.$emit('callAction', notification_type);
  }
}
